import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import UploadPage from './pages/UploadPage';
import TableSelectionPage from './pages/TableSelectionPage';
import GeneratePage from './pages/GeneratePage';
import ProductOverviewPage from './pages/ProductOverviewPage';
import CreateTaskPipelinePage from './pages/CreateTaskPipelinePage';
import DataWorkspacePage from './pages/DataWorkspacePage';
import TdmTaskLifecyclePage from './pages/TdmTaskLifecyclePage';
import RunFlowchartPage from './pages/RunFlowchartPage';
import ExportDestinationPage from './pages/ExportDestinationPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import { AppProvider } from './context/AppContext';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { ThemeProvider } from './context/ThemeContext';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <AppProvider>
          <NotificationProvider>
        <Router>
          <div className="App">
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/" element={<Layout />}>
                <Route index element={<Navigate to="overview" replace />} />
                <Route path="overview" element={<ProductOverviewPage />} />
                <Route path="create-scenarios" element={<UploadPage />} />
                <Route path="tdm-lifecycle" element={<TdmTaskLifecyclePage />} />
                <Route path="create-pipeline" element={<CreateTaskPipelinePage />} />
                <Route path="workspace" element={<DataWorkspacePage />} />
                {/* Redirect /runs to main page since UploadPage now has runs sidebar */}
                <Route path="runs" element={<Navigate to="/" replace />} />
                {/* Specific routes first, then general route */}
                <Route path="run/:runId/select" element={<TableSelectionPage />} />
                <Route path="run/:runId/generate" element={<GeneratePage />} />
                <Route path="run/:runId/export" element={<ExportDestinationPage />} />
                <Route path="run/:runId" element={<RunFlowchartPage />} />
                {/* Redirect old routes to new combined page */}
                <Route path="run/:runId/business-rules" element={<Navigate to="../generate" replace />} />
                <Route path="run/:runId/results" element={<Navigate to="../generate" replace />} />
              </Route>
            </Routes>
          </div>
        </Router>
      </NotificationProvider>
      </AppProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

